import React from "react";
import ARROW from "./../../../../../assets/images/chevron_down.svg";
import Accordion from 'react-bootstrap/Accordion';
import PharmacyOrderDetail from "./PharmacyOrderDetail";
import PharmacyOrderItemsList from "./PharmacyOrderItemsList";
import PharmacyOrderActions from "./PharmacyOrderActions";
import PharmacyOrderItemKeyValueDetails from "./children/PharmacyOrderItemKeyValueDetails";
import {useDispatch} from "react-redux";
import {updatePharmacyOrderLastAssignTime} from "../../../../../redux/actions/orders";
const PharmacyOrderItem = (props) => {
    const dispatch = useDispatch()
    const {
        id,
        customer_contact_name,
        jalali_created_at,
        drug_store_fa_status,
        status,
        batch_order_id,
        delivery_type
    } = props.order;
    const updateLastAssignTime = () => {
        if (status === 'vendor_assigned'){
            dispatch(updatePharmacyOrderLastAssignTime(id));
        }
    };
    return (
        <Accordion className="bg-white shadow-sm lab-order-item-holder">
            <Accordion.Toggle  variant="link" eventKey={id}
                               className="lab-order-item bg-white"
                               onClick={() => updateLastAssignTime()}
            >
                <div className="order-title">
                    {customer_contact_name} {" "} - ({jalali_created_at}){" "}
                    <span className="order-fa-status">{drug_store_fa_status}</span>
                    {" "} (کد سفارش  :  {id}) {" "}
                </div>
                <div className="batch-section-holder">
                    {
                        (delivery_type !== undefined && delivery_type === 'on_time') && (
                            <div className="onTimeBadge">
                                ارسال فوری
                            </div>
                        )
                    }

                    {
                        batch_order_id !== null ? (
                            <div className="batch-order-id">Batch Order ID : {batch_order_id}</div>
                        ) :
                        null
                    }
                    <img className="expand-btn" src={ARROW} alt="arrow" width={15} />
                </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={id}>
                <div className="lab-order-details bg-white row">
                    <div className="col-lg-7 col-md-7 col-sm-12">
                        <PharmacyOrderDetail order={props.order} />
                        <PharmacyOrderItemsList order={props.order} />
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-12 lab-order-actions-holder">
                        <div className="key-value-details">
                            <PharmacyOrderItemKeyValueDetails {...props.order} />
                        </div>
                        <PharmacyOrderActions order={props.order} />
                    </div>
                </div>
            </Accordion.Collapse>
        </Accordion>
    );
};

export default PharmacyOrderItem;
